import { Component, inject } from '@angular/core';
import {
  AttachmentDetailDto,
  AttachmentFilterDto,
  AttachmentService,
  TenantDetailDto,
} from '@artemis-software/wr-api';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NbDateService } from '@nebular/theme';
import { currentTenantId, isInternalTenant } from '@/utils/admin-utils';
import { toSelectedRange } from '@/utils/filter-range-utils';

@Component({
  standalone: false,
  selector: 'wr-archive-page',
  templateUrl: './archive-page.component.html',
  styleUrls: ['./archive-page.component.scss']
})
export class ArchivePageComponent {

  private readonly formBuilder = inject(FormBuilder);
  private readonly dateService = inject(NbDateService);
  private readonly attachmentService = inject(AttachmentService);

  protected readonly TenantTypeEnum = TenantDetailDto.TypeEnum;

  form!: FormGroup;

  isInternalTenant = isInternalTenant();
  currentTenantId = currentTenantId();

  constructor() {
    const startOfMonth = this.dateService.getMonthStart(this.dateService.today());
    const endOfMonth = this.dateService.getMonthEnd(this.dateService.addMonth(startOfMonth, 1));

    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
      tenantId: this.formBuilder.control(undefined),
      building: this.formBuilder.control(undefined),
      buildingId: this.formBuilder.control(undefined),
      selectedRange: new FormControl({
        start: startOfMonth,
        end: endOfMonth,
      }),
      tag: this.formBuilder.control(''),
      tagId: this.formBuilder.control(undefined),
      isArchive: this.formBuilder.control(false),
    });

    this.form.controls['tag'].valueChanges.subscribe((value) => {
      this.form.controls['tagId'].setValue(value ? value.id : undefined);
    });

    this.form.controls['building'].valueChanges.subscribe((value) => {
      this.form.controls['buildingId'].setValue(value ? value.id : undefined);
    });

    this.form.controls['tenantId'].valueChanges.subscribe(() => {
      this.form.controls['building'].setValue(undefined);
      this.form.controls['buildingId'].setValue(undefined);
    });
  }

  readonly loadAttachments = (filter: AttachmentFilterDto) =>
    this.attachmentService.findAllDetailDtos({ ...filter, selectedRange: toSelectedRange(filter.selectedRange) });

  readonly getCount = (filter: AttachmentFilterDto) =>
    this.attachmentService.getCount({ ...filter, selectedRange: toSelectedRange(filter.selectedRange) });

  readonly getInspectionLink = (attachment: AttachmentDetailDto) =>
    (['/inspection', attachment.inspectionId, 'general']);

  readonly exportFileName = (attachment: AttachmentDetailDto): string => {
    if (attachment.fileName && attachment.fileEnding) {
      return `${attachment.fileName}.${attachment.fileEnding}`;
    }
    return attachment.fileName ?? '';
  };

  readonly exportTags = (attachment: AttachmentDetailDto): string =>
    (attachment.tags ?? []).map((tag) => tag.name).join(', ');

}
